import React from 'react';
import moment, { Moment } from 'moment';
import { DatePicker } from 'antd';
import { RangeValue } from 'rc-picker/lib/interface';

import { TimesheetStatusReportFilters } from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/TimesheetStatusReportFilter/TimesheetStatusReportFilter';
import { TimesheetStatusReportFilterTypes } from '../enums/TimesheetStatusReportFilterTypes.enum';

type Props = {
  filters: TimesheetStatusReportFilters;
  onChange: (
    data: TimesheetStatusReportFilters,
    type: TimesheetStatusReportFilterTypes,
  ) => void;
};

export default function DateFilter(props: Props) {
  const { filters, onChange } = props;

  const handleSelectDate =
    (type: TimesheetStatusReportFilterTypes) => (date: RangeValue<Moment>) => {
      if (date) {
        return onChange(
          {
            ...filters,
            [type]: {
              startDate: date[0],
              endDate: date[1],
            },
          },
          type,
        );
      }

      onChange(
        {
          ...filters,
          [type]: undefined,
        },
        type,
      );
    };

  return (
    <DatePicker.RangePicker
      key="filterByDate"
      name="filterByDate"
      format="MM/DD/YYYY"
      separator="-"
      className="d-flex"
      value={
        filters[TimesheetStatusReportFilterTypes.Date]
          ? [
              moment(filters[TimesheetStatusReportFilterTypes.Date]?.startDate),
              moment(filters[TimesheetStatusReportFilterTypes.Date]?.endDate),
            ]
          : undefined
      }
      onChange={handleSelectDate(TimesheetStatusReportFilterTypes.Date)}
      data-id="dateFilterField"
    />
  );
}
